export default __webpack_public_path__ + "../staticImages/550x330-placeholder.png";